exports._default = require("./emotion-cache.browser.cjs.js").default;
